import BusinessChoosePlaceCap from "./BusinessChoosePlaceCap";

export default BusinessChoosePlaceCap;